<template>
  <div v-if="!props.isprintView && props.isopen && !view.isZoom()" :style="projectbackgroundstyle"   class="projectbackground"></div>
  
  <div
    v-if="!props.isprintView"
    :id="`${props.project.id}`"
    :style="[{ height: `${getRowHeight(props.isprintView)}px`}, projectRowOpenStyle()]"
    class="project-row resource-row !border-b !border-gray-100 !border-[1px]"
	  :class="{ spacer: props.project.isspacer }"
    ref="projectEl"
	  @handleClick="deselect"
	  @pointerdown="deselect"
  >  
      <Task v-if="!props.project.isspacer"
          :key="`${props.project.id}-${updateProject}`"
	        :isopen="props.isopen"
	        :id="`${props.project.id}`"
			    :isproject="true"
	        :project="props.project"
          :isprintView="props.isprintView"
			    :bookings="props.bookings"
	        :label="props.project.name"
	        :start="startRef"
	        :end="endRef"
          :startDate="props.startDate"
          :endDate="props.endDate"
			    :inproject="true"
			    :configs="props.configs"
			    @bookingDone="handleBookingDone"
			    @cancel="handleCancel"
			    @taskChange="projectChangeHanlder"
	  />
  </div>

  <div v-if="props.isopen" v-for="(u, idx) in activeUsers"
      :id="`${props.project.id}-${u.id}`"
      :style="[{ height: `${getRowHeight(props.isprintView)}px`}, userRowOpenStyle(idx)]"
      :class="['resource-row !border-b !border-[1px]', props.isprintView ? '!border-gray-200' : '!border-gray-100']"  ref="projectEl">
       <Task v-for="b in getUserBookings(pid2pnames, props.bookings, props.project, u, props.isprintView)"
	    :id="`${props.project.id + '-' + u.id + '-' + b.id}`"
		  :isproject="false"
      :isprintView="props.isprintView"
      :project="props.project"
		  :user="u"
		  :booking="b"
		  :bookings="props.bookings"
	    :label="`${b.label}`"
	    :start="b.start"
	    :end="b.end"
      :startDate="props.startDate"
      :endDate="props.endDate"
		  :inproject="b.inproject"
		  :configs="props.configs"
		  @bookingDone="handleBookingDone"
	  />

  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import {bus, cleanx, getUserBookings, getWidthPerDay, getRowHeight, dayMs, applyResoureFilter} from "./planner.js";
import Task from './Task.vue';
import * as d3 from 'd3';

import {useViewStore} from "@/stores/viewStore"

const view = useViewStore();

const props = defineProps({
  startDate: Date,
  endDate: Date,
  project: Object,
  isprintView: Boolean,
  projects: {type: Array, required: true},
  users: {type: Array, required: true},
  bookings: {type: Array, required: true},
  isopen: {type: Boolean, required: true},
  resourceFilter: {type: Object, required: true},
  configs: { type: Array, required: true },
})

const emit = defineEmits(['bookingDone', "projectChangeDone", "deselect", "cancel"])

const widthPerDay = getWidthPerDay(props.isprintView, view.zoomWidthPerDay)

const updateProject = ref(0)
// Local open/close state
const isOpen = ref(false)

const activeUsers = computed(() =>
  props.users.filter(u => applyResoureFilter(props.resourceFilter, props.project, u))
)

function projectRowOpenStyle() { return {} }
function userRowOpenStyle(_idx) { return {} }

// Ref to the main element
const projectEl = ref(null)

const startDateStr = props.configs.find(c => c.name === "startdate").value;
const endDateStr = props.configs.find(c => c.name === "enddate").value;
const startDate =  new Date(startDateStr + "T00:00:00");
const endDate = new Date(endDateStr + "T00:00:00");

const totalDays = (endDate - startDate) / dayMs;

const x = d3.scaleUtc().domain([startDate, endDate]).range([0, totalDays * widthPerDay]);

const borderWidth = 10;

const startRef = ref(props.project.start)
const endRef   = ref(props.project.end)

watch(
  () => [props.project.start, props.project.end],
  ([newStart, newEnd]) => {
    startRef.value = newStart
    endRef.value   = newEnd
  }
)

const projectbackgroundstyle = computed(() => {
	
  let active_users = props.users.filter(u => applyResoureFilter(props.resourceFilter, props.project, u))
  const backgroundHeight = getRowHeight(props.isprintView) * (active_users.length + 1);
	
  return {
	position: 'absolute',
	left: `${cleanx(x, startRef.value)}px`,
	width: `${cleanx(x, endRef.value) - cleanx(x, startRef.value) + widthPerDay}px`,
	height: `${backgroundHeight}px`,
	backgroundColor: props.project.color + "33",
	zIndex: 0,
  }
});

function projectChangeHanlder(cstart, cend) {
  console.log("projectChangeHanlder cstart=" + cstart + " cend=" + cend) 
  startRef.value = new Date(cstart + "T00:00:00.000Z");
  endRef.value   = new Date(cend + "T00:00:00.000Z");
}

function handleBookingDone(params) {
  if (params["isproject"]) {
	  console.log("projectChangeDone");
	  emit('projectChangeDone', params)		
  } else {
    if (params["newpstart"]) {
      startRef.value = params["newpstart"]
      endRef.value = params["newpend"]
      console.log("startRef.value=" + startRef.value + " endRef.value=" + endRef.value)
      updateProject.value++;
    }
	  emit('bookingDone', params)		
  }
}

function handleCancel() {
  startRef.value = props.project.start;
  endRef.value   = props.project.end;
  emit('cancel');
}

function deselect(e) {
  emit('deselect')		
}


const pid2pnames = ref(props.projects.reduce((acc, entity) => {
  acc[entity.id] = entity.name
  return acc
}, {}));

function onProjectUpdated(data) {
  console.log('received', data)

  if (data["booking_action"] === props.project.id && data["newpstart"]) {
    startRef.value = data["newpstart"]
    endRef.value = data["newpend"]
    console.log("onProjectUpdated startRef.value=" + startRef.value + " endRef.value=" + endRef.value)
  }
	updateProject.value++;

}

onMounted(() => {
  bus.on('project-updated', onProjectUpdated)
})

onUnmounted(() => {
  bus.off('project-updated', onProjectUpdated)
})

</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  background: #f4f4f4;
  padding: 4px 8px;
  cursor: pointer;
}

.content {
  padding: 8px;
  background: #fff;
}

.toggle {
  font-size: 0.8em;
}

.resource-row {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  overflow: hidden; /* or auto, depending on layout */
}

.resource-row.spacer {
  background-color: rgb(250, 250, 250);
}

</style>
